import { render, staticRenderFns } from "./UiSelect.vue?vue&type=template&id=06cce5d8&"
import script from "./UiSelect.vue?vue&type=script&lang=ts&"
export * from "./UiSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports